import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AlertMessageService {
	private subject = new Subject<any>();

	apply(alert: any) {
		this.subject.next(alert);
	}

	getService(): Observable<any> {
		return this.subject.asObservable();
	}
}
